<template>
  <div>
    <div>
      <div >
          <b-row class="align-center">
            <b-col v-if="!HasStaffs" class="text-info"><i> {{$t('connector.label.nodata')}}</i></b-col>
          </b-row>

        <b-button v-if="HasStaffs" v-b-toggle="'list-invisible-personnels'" class="m-1" variant="info">
          <span class="when-open"
            ><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span
          >
          <span class="when-closed"
            ><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span
          >
          {{ $t("connector.label.list_personnel") }}
        </b-button>
        <b-button v-if="HasImport" 
          variant="warning"
          @click="getFromAPI"
          >{{$t('connector.btn.get_from_api')}}</b-button>
          &nbsp;
          <b-badge variant="dark" v-if="personnels === null">{{$t('connector.label.nodatanetsoins')}}</b-badge>
          <b-badge variant="success" v-if="personnels">{{ $t("connector.label.nb_personnels_netsoins", [personnels.length])}} </b-badge>
          <b-button v-if="personnels && !useProxy && connector === 'NETSOIN'" @click="GetLink()">
            <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download") }}
          </b-button>
        <b-collapse v-model="listVisible" id="list-invisible-personnels">

          <b-table
            v-if="HasStaffs"
            :fields="fields"
            :items="staffs"
            small
            responsive="sm"
            :tbody-tr-class="rowClass"
          >
            <template #cell(saved)="row">
               <b-col>
                  <font-awesome-icon
                    v-if="row.item.saved && (personnels === null || mappingExists(row.item.ext_uri))"
                    :icon="['fas', 'check-square']"
                  />
                  <font-awesome-icon
                    v-else-if="row.item.saved"
                    v-b-tooltip.hover
                    :title="$t('connector.tooltip.mapping_not_found')"
                    class="text-warning"
                    :icon="['fas', 'exclamation-triangle']"
                  />
                  <font-awesome-icon v-else :icon="['fas', 'square']" />
               </b-col>
            </template>
            <template #cell(sest_id)="row">
              <b-col>{{ row.item.sest_id }}</b-col>
            </template>            
            <template #cell(staf_is_male)="row">
              <b-col v-if="row.item.staf_is_male"
                ><font-awesome-icon :icon="['fas', 'mars']" class="male"
              /></b-col>
              <b-col v-else
                ><font-awesome-icon :icon="['fas', 'venus']" class="female"
              /></b-col>
            </template>
            <template #cell(staf_lastname)="row">
              <b-col>{{ row.item.staf_lastname }}</b-col>
            </template>
            <template #cell(staf_firtsname)="row">
              <b-col>{{ row.item.staf_firtsname }}</b-col>
            </template>
          
            <template #cell(ext_uri)="row">
              <b-col>
                <b-input-group size="sm">
                <b-form-select id="perso"
                  v-b-tooltip.hover :title="(row.item.ext_uri === null) ? '' : row.item.ext_uri"
                  :disabled="row.item.ext_uri === null && !row.item.sest_is_enable"
                  v-model="row.item.ext_uri" @input="setModified($event, row.item)">
                  <option :value="null" disabled>{{$t('connector.option.personnel')}}</option>
                  <option
                    v-if="row.item.saved && !mappingExists(row.item.ext_uri)"
                    :value="row.item.ext_uri"
                    disabled
                  >
                    {{ personnels === null
                      ? $t('connector.option.stored_mapping', [mappingLabel(row.item.ext_uri)])
                      : $t('connector.option.mapping_not_found', [mappingLabel(row.item.ext_uri)]) }}
                  </option>
                  <option
                    :key="personnel.Uri"
                    v-for="personnel in personnels"
                    :value="personnel.Uri"
                  >
                    {{ personnel.Fullname }}
                  </option>
                </b-form-select>
                </b-input-group>
              </b-col>
            </template>
            <template #cell(update)="row">
              <b-row class="details">
                <b-col>
                  <b-button
                  v-b-tooltip.hover :title="$t('connector.tooltip.unmap')"
                  size="sm"
                  @click="Reset(row.item)"
                  :disabled="!(SaveEnabled )"
                  variant="outline-danger"
                  >X
                  </b-button>    
                  <span class="d-inline-block" tabindex="0"
                  v-b-tooltip.hover :title="!(SaveEnabled && row.item.modified) ? '' : $t('connector.tooltip.cancel')"
                  >              
                  <b-button
                  size="sm"
                  @click="Undo(row.item)"
                  :disabled="!(SaveEnabled && row.item.modified)"
                  class="editbtn"
                  >
                    <font-awesome-icon :icon="['fa', 'undo']" />
                  </b-button>
                  </span>
                  <b-button
                    v-b-tooltip.hover :title="!(SaveEnabled && row.item.modified) ? '' : $t('btn.save')"
                    size="sm"
                    :disabled="!(SaveEnabled && row.item.modified)"
                    @click="SaveMapping(row.item)"
                    :variant="(row.item.modified)? 'danger' :'secondary'"
                    class="editbtn"
                    >
                    <font-awesome-icon :icon="['fas', 'save']" />
                    </b-button
                  ></b-col
                >
              </b-row>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeSync } from "normalize-diacritics";
import { MappedStaffs, SetStaffUri } from "../../services/staffs";
import { Personnels, Links} from "../../services/netsoins"
import ApiTitan, { normalizeTitanStaff } from "../../services/titan";
import ApiNetsoins from "../../services/proxyNetsoins";

export default {
  name: "ListPersonnels",
  props: {
    keyapi: { 
      type: String,
      default: null 
    },
    urlapi: { 
      type: String, 
      default: null 
    },
    config: {
      type: Object,
      default() { return {} },
    },
    connector: {
      type: String,
      default: 'NETSOIN',
    },
    esta: { type: Number, default: null},
    cnt: { type: Number, default: null},
    ctx: { type: Number, default: null},
    useProxy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: this.$i18n.t('connector.label.list_personnel'), 
      fields: [
        {
          saved: {
            label: this.$i18n.t('label.saved'),
            sortable: true,
            tdClass: 'align-middle',
          }
        },
        {
          staf_lastname: {
            label:  this.$i18n.t('label.name'),
            sortable: true,
            tdClass: "align-middle  text-left",
          },
        },
        {
          staf_firstname: {
            label: this.$i18n.t('label.firstname') ,
            sortable: true,
            tdClass: "align-middle  text-left",
          },
        },
        {
          staf_is_male: {
            label: this.$i18n.t('label.gender'),
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          ext_uri: {
            label: this.$i18n.t('connector.label.uriterranga') ,
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          sest_id: {
            label: this.$i18n.t('label.identifiant') ,
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          update: {
            label: this.$i18n.t('label.action') ,
            sortable: false,
            tdClass: "align-middle",
          },
        },        
      ],
      staffs: null,
      personnels: null,
      listVisible: false,
    };
  },
  async mounted() {
    this.getStaffs();
    this.listVisible = this.HasStaffs;
  },
  methods: {
    async getStaffs() {
      this.staffs = await MappedStaffs(this.esta, this.cnt);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;      
      if (!item?.sest_is_enable) return "notenabled"
      if (item.saved && this.personnels !== null && !this.mappingExists(item.ext_uri)) return "uncompleted";
      if (item.saved) return "gosted";
      if (item?.ext_uri !== ""  ) return "uncompleted";
    },
    checkMapping(){
      if (this.staffs)
        this.staffs.map(p => {
          p.modified = false;
          p.old_uri = p.ext_uri;
          if (p.ext_uri === null){
            p.ext_uri = this.checkStaff(p.staff_lastname, p.staff_firstname);
            if (p.ext_uri) {
              p.modified = true;
              p.saved = false;
            }
        }
          return p;
        })
      else this.staffs = null
    },
    checkStaff(nom, prenom) {
      // Force la normalisation car différent selon la source
      let vnom = normalizeSync(nom || '');
      let vprenom = normalizeSync(prenom || '');

      const i = this.personnels.find((r) => {
          const textnom = normalizeSync(r.Nom || '');
          if (vnom.includes(textnom)){
            const textprenom = normalizeSync(r.Prenom || '');
            return vprenom.includes(textprenom);
          }
          return false;
        
      });
      if (i) return i.Uri;
      return null;
    },
    mappingExists(uri) {
      return this.personnels?.some(personnel => personnel.Uri === uri) ?? false;
    },
    mappingLabel(uri) {
      return typeof uri === "string" && uri.trim() !== ""
        ? uri
        : this.$t('connector.option.empty_mapping');
    },
    setPersonnels(result) {
      this.personnels = result.data.map((m) => {
        return {
          Nom: m.Nom,
          Prenom: m.Prenom,
          Fullname: `${m.Nom} ${m.Prenom}`,
          Enabled: m.Actif === "1",
          Uri: m.Uri
        };
      }).sort((a, b) => a.Fullname.toLowerCase().localeCompare(b.Fullname.toLowerCase()));
      this.checkMapping();
    },
    async getFromAPI(){
      let values = [];
      if (this.connector === 'NETSOIN') {
        if (this.useProxy) {
          const api = new ApiNetsoins(this.keyapi, this.urlapi);
          values = await api.getStaffs();
        }
        else {
          values = await Personnels({uri:this.urlapi, key:this.keyapi});
        }
      }  else if (this.connector === 'TITAN') {
        const api = new ApiTitan(this.config.apilogin, this.config.apipassword, this.config.apikey, this.config.apiurl, this.config.ext_uri);
        values = (await api.getStaffs()).map(normalizeTitanStaff)
      }
      if (values) {
        this.setPersonnels({data: values});
      }
    },
    async SaveMapping(item){
      item.saved = await SetStaffUri(this.esta, this.cnt,item.sest_id, item.ext_uri);
      if (item.saved) {
        item.old_uri = item.ext_uri;
        item.modified = false;
      }      
    },
    setModified(value,item){
      item.modified = (item.old_uri !== item.ext_uri);
      item.saved = !(item.old_uri !== item.ext_uri );
    },
    Undo(item){
      item.ext_uri = item.old_uri;
      item.modified = false;
      item.saved = (item.old_uri === item.ext_uri && item.ext_uri !== null);
     },
    Reset(item){
      item.ext_uri = null;
      item.modified = (item.old_uri !== item.ext_uri);
      item.saved = !(item.old_uri !== item.ext_uri );      
    },
    GetLink(){
      var link = Links("personnels", {uri:this.urlapi, key:this.keyapi});
      if (link) {
        Object.assign(document.createElement('a'), { target: '_blank', href: link }).click();
      }
    }    
  },
  computed:{   
    HasImport(){
      return (this.keyapi !== null && this.urlapi !== null) || (
        this.config && this.config.apilogin !== null && this.config.apipassword !== null && this.config.apikey !== null && this.config.apiurl !== null && this.config.ext_uri !== null
        ) && this.HasStaffs;
    },
    HasStaffs() {
      return !!this.staffs;
    },
    SaveEnabled() {
      return (!!this.ctx && this?.ctx > 0);
    }
}
};
</script>
<style>
.notenabled {
  color: lightgray;
  background-color: gray;
  text-decoration-line: line-through;
}
.gosted {
  color: grey;
  background-color: lightgray;
}
.uncompleted {
  color: red;
  background-color: rgb(247, 222, 222);
}
.details {
  display: flex;
}
.editbtn {
  margin-left: 0.2rem;
}
</style>
